import { useCallback } from "react";
import JSZip from "jszip";

interface ZipResult {
  zipFile: Blob;
}

export const useHtmlToZip = () => {
  const handleHtmlToZip = useCallback(
    async (
      htmlString: string | undefined,
      fileName: string = "template.html",
    ): Promise<ZipResult> => {
      const zip = new JSZip();

      zip.file(fileName, htmlString ?? "");
      const zipFile = await zip.generateAsync({ type: "blob" });

      return { zipFile };
    },
    [],
  );

  return handleHtmlToZip;
};
